import { resolveDesktopModuleDatefieldDateFilterParameter } from 'src/stores/_infrastructure/dateTimeRangeQueryValue';

import { DateRangeSelection } from 'src/models/common';
import { GenericActivityListPagination, GenericActivityListSort } from 'src/models/genericActivityList';
import { AbstractQuery } from 'src/models/query';

export class GetTheNoteModuleBoxesForTheUserQuery extends AbstractQuery {
	name = 'IFS_DesktopModule_Note_Query_Queries_GetTheNoteModuleBoxesForTheUserQuery';
	page = 1;
	subscribeForUpdates = false;
}

export class GetTheNoteModuleNotesForTheUserQuery extends AbstractQuery {
	limit = 100;
	name = 'IFS_DesktopModule_Note_Query_Queries_GetTheNoteModuleNotesForTheUserQuery';
	page = 1;
	sort: Array<GenericActivityListSort> = [
		{
			direction: 'DESC',
			property: 'timestamp',
		},
	];
	standardFilterSelection = '';

	constructor(
		view: string,
		date: DateRangeSelection | string,
		boxIdFilter: Array<string>,
		userIdFilter: Array<number>,
		searchTerm: string,
		hiddenSearchTerm: string,
		pagination: GenericActivityListPagination,
		sort: GenericActivityListSort,
		suppressBoxCustomCoupling = false
	) {
		super();

		this.page = pagination.page;
		this.limit = pagination.rowsPerPage;
		this.sort = [sort];

		if (view === 'open') {
			this.standardFilterSelection = 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonUnfinished';
			this.parameters.push({
				DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButton:
					'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonUnfinished',
			});
		} else if (view === 'all') {
			this.standardFilterSelection = 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonAll';
			this.parameters.push({
				DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButton:
					'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonAll',
			});
		} else if (view === 'mine') {
			this.standardFilterSelection = 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonMine';
			this.parameters.push({
				DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButton:
					'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonMine',
			});
		} else if (view === 'custom') {
			this.standardFilterSelection = 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonCustom';
			this.parameters.push({
				DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButton:
					'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonCustom',
			});
		}

		this.parameters.push({
			DesktopModuleToolbarButtonGlobalizationFilter: true,
		});
		this.parameters.push({ DesktopModuleToolbarButtonArchivFilter: false });

		if (searchTerm !== '' && searchTerm !== undefined) {
			this.parameters.push({
				DesktopModuleToolbarTextfieldSearchField: searchTerm,
			});

			this.parameters.push({
				DesktopModuleToolbarHiddenfieldSearchField: hiddenSearchTerm,
			});

			this.parameters.push({
				DesktopModuleToolbarDatefieldDateFilter:
					'DesktopModuleToolbarSegmentedButtonTimeRangeSelectionButtonAll',
			});
		} else {
			this.parameters.push({
				DesktopModuleToolbarDatefieldDateFilter: resolveDesktopModuleDatefieldDateFilterParameter(date),
			});
		}

		this.disableSubscriptionsWhileSearchIsActive(searchTerm, hiddenSearchTerm);

		// Task 3.1f: die Box→Custom-Kopplung kollabiert alle drei Ansichts-Slices (Offen/Meine/Alle) auf dieselbe
		// Custom-Query, sobald Boxen ohne User-Filter aktiv sind (Backend: last-wins auf StandardFilterSelectionButton
		// → 8/8/8). Isolierte gespeicherte-Listen-Tabs unterdrücken die Kopplung, damit jede Ansicht view-scoped mit
		// den Listen-Boxen schneidet. Default-Store ('noteList') behält die klassische Custom-Kollaps-Kopplung (byte-
		// identisch). Backend-Schnittmenge nur für taskList wire-verifiziert; übrige Module als analog angenommen.
		if (!suppressBoxCustomCoupling && boxIdFilter.length > 0 && userIdFilter.length == 0) {
			this.parameters.push({
				DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButton:
					'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonCustom',
			});
		}

		this.parameters.push({ DesktopModuleCustomFilterCondition: {} });

		this.parameters.push({
			DesktopModuleToolbarCycleButtonDirection: 'DesktopModuleToolbarCycleButtonDirectionBidirectional',
		});

		this.parameters.push({ DesktopModuleBoxIds: boxIdFilter });

		this.parameters.push({
			DesktopModuleToolbarSplitButtonUserFilter: userIdFilter,
		});
	}

	uniqueQueryIdentifier(): string {
		return this.createStableIdentifier({
			standardFilterSelection: this.standardFilterSelection,
		});
	}
}
